<template lang="html">

  <v-chip v-bind:class="['status', status]" label small>{{ status }}</v-chip>

</template>

<script>
export default {
  props: { status: { type: String, required: true } }
}
</script>

<style lang="css" scoped>
  .status.enabled { background: #2ECC40 !important; color: white; }
</style>
